import ReactDOM from "react-dom";
import { ModalHeader, Modal, ModalBody } from "reactstrap";
import styles from "./Modal.module.scss";
import { GrPrevious, GrNext } from 'react-icons/gr'

function DialogBody({ visible, toggle, currentModalIndex, setCurrentModalIndex, selectedRoundCardsLength, showPrevNext, ...props }) {
  return (
    <div className={styles.ModalDialog}>
      <Modal
        toggle={toggle}
        isOpen={visible}
        centered
        size={props.size ? props.size : "lg"}
        backdrop="static"
      >
        <ModalHeader
          className={`${styles.header} ${props.className && props.className === "member-popup"
              ? "memHeader"
              : ""
            }`}
          toggle={toggle}
          style={{
            borderBottom: "none",
            position: 'relative'
          }}
        >
          {props?.title}
          <div className={styles.subTitle}>{props?.subTitle}</div>
          {
            props?.source === 1 &&
            <span className={`${styles.ribbon}`} />
          }
        </ModalHeader>
        {
          showPrevNext &&
            <div style={{position: 'absolute', right: '10%', top: '13px'}}>
              <span className="modalCount">{currentModalIndex && currentModalIndex != NaN ? (currentModalIndex + 1) : 1} <span className="countOfText">of</span> {selectedRoundCardsLength && selectedRoundCardsLength != NaN ? (selectedRoundCardsLength + 1) : 1}</span>
              <button title="Previous Applicant" className="prevNextBtns mx-3" disabled={currentModalIndex === 0} onClick={() => setCurrentModalIndex(currentModalIndex - 1)}>
                <GrPrevious className="prevIcon"/>
              </button>
              <button title="Next Applicant" className="prevNextBtns" disabled={currentModalIndex === selectedRoundCardsLength} onClick={() => setCurrentModalIndex(currentModalIndex + 1)}>
                <GrNext />
              </button>
            </div>
        }
        {props.pbody && props.pbody}
        <ModalBody
          className={`${styles.body} ${props.bodyClass ? props.bodyClass : ""}`}
        >
          {props.children}
        </ModalBody>
      </Modal>
    </div>
  );
}

const ModalDialog = (props) =>
  props.visible
    ? ReactDOM.createPortal(DialogBody(props), document.body)
    : null;

export default ModalDialog;
